<script lang="ts" setup>
	import { twMerge, type ClassNameValue } from 'tailwind-merge'
	import type { LabelContext } from '~/stores/products/types'

	defineProps<{
		list: Array<{
			title: LabelContext
			description?: LabelContext
			collection?: Array<LabelContext>
		}>
		caption?: string
		trail?: boolean

		listStyleCls?: ClassNameValue
		listCls?: ClassNameValue
	}>()
	const template = useTemplateRef('template')
	defineExpose({ template })
</script>
<template>
	<div ref="template">
		<strong class="text-[#094163] font-semibold sm:text-lg text-base">
			{{ caption }}
		</strong>
		<ul class="relative space-y-10 mt-5">
			<li
				v-for="(item, index) in list"
				:key="'list-' + index"
				:class="[
					{ trails: trail && list.length > 0 },
					twMerge('last:before:border-l-0 before:border-base-primary', listCls)
				]"
			>
				<div class="flex items-start gap-x-3 relative">
					<div
						v-if="trail && list.length > 0"
						:class="
							twMerge(
								'w-[24px] text-main h-[24px] font-medium text-sm border border-base-primary bg-[#ECF8F5] rounded-full flexed justify-center items-center flex-none relative z-10',
								listStyleCls
							)
						"
					>
						{{ index + 1 }}
					</div>
					<div>
						<div>
							<span class="font-medium text-base text-gray-800" :class="item.title.ui">
								{{ item.title.text }}
							</span>
							<p
								v-show="item.description?.text"
								class="mt-2 font-medium text-sm sm:leading-[24px]"
								:class="item.description?.ui ?? ''"
								v-html="item.description?.text ?? 'N/A'"
							/>
						</div>
						<ul v-if="item?.collection" class="relative list pl-2">
							<li
								v-for="(collectionItem, index) in item.collection"
								:key="index"
								class="list-item text-sm text-[#344053] list-inside list-disc"
							>
								{{ collectionItem.text }}
							</li>
						</ul>
					</div>
				</div>
			</li>
		</ul>
	</div>
</template>

<style scoped>
	.trails {
		@apply before:h-[90%] before:absolute before:top-0 before:border-l-2  before:border-dotted before:last:border-none before:left-3;
	}
</style>
